import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserService } from '../services/user.service';

export const claimGuard: CanActivateFn = (route) => {
  const authService = inject(UserService);
  const requiredClaim = route.data['requiredClaim'];
  if (!authService.hasClaim(requiredClaim)) {
    authService.logout();
    return false;
  }
  return true;
};
